var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "update" }, [
    _c(
      "div",
      {
        staticClass: "update__wrapper",
        class: { "not-subscribe": _vm.notSubscribe },
      },
      [
        _vm.tags
          ? _c(
              "div",
              { staticClass: "update__tags" },
              _vm._l(
                _vm.tags.filter((item, index) => index < 3),
                function (tag, index) {
                  return _c("Tag", {
                    key: index,
                    attrs: {
                      text: tag.name,
                      color: "red",
                      link: tag.view_taxonomy_term,
                      uuid: tag.uuid,
                      tid: tag.tid,
                    },
                  })
                }
              ),
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.date
          ? _c(
              "div",
              { staticClass: "update__date" },
              [_c("Date", { attrs: { text: _vm.date } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasAccess
          ? _c(
              "div",
              { staticClass: "update__title" },
              [
                _vm.link
                  ? _c("nuxt-link", {
                      attrs: {
                        to: _vm.link,
                        target: _vm.newTab ? "_blank" : "_self",
                      },
                      domProps: { innerHTML: _vm._s(_vm.title) },
                    })
                  : _c("p", [_vm._v(_vm._s(_vm.title))]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.hasAccess
          ? _c(
              "div",
              {
                staticClass: "update__title",
                staticStyle: { color: "#262a2e !important" },
              },
              [
                _c("p", { staticClass: "unauthorised" }, [
                  _vm._v(_vm._s(_vm.noAccessShort)),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "update__relevant" }, [
          _c("div", { staticClass: "update__relevant-number" }, [
            _vm._v("\n        " + _vm._s(_vm.amountRelevant) + "\n      "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "update__relevant-info" }, [
            _vm._v("\n        " + _vm._s(_vm.infoRelevant) + "\n      "),
          ]),
        ]),
        _vm._v(" "),
        _vm.notSubscribe ? _c("Tooltip") : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }